import { get } from 'lodash';
export const getValueFromListing = (value: any, listing: any) => {
  return listing && listing.find((el: any) => el.id === value);
};
export const getLabelInboxe = (
  row: any,
  listings: any,
  isTransaction: boolean,
) => {
  if (isTransaction) {
    return get(
      getValueFromListing(
        get(row, 'transactionInboxeArea.managerInboxesId', ''),
        get(listings, 'managerInboxes'),
      ),
      'title',
      '',
    );
  } else {
    return get(
      getValueFromListing(
        get(row, 'managerNotificationType.managerInboxesId', ''),
        get(listings, 'managerInboxes'),
      ),
      'title',
      '',
    );
  }
};

export const getLabelSubInboxe = (
  row: any,
  listings: any,
  isTransaction: boolean,
) => {
  if (isTransaction) {
    return get(
      getValueFromListing(
        get(row, 'transactionInboxeArea.transactionAreaId', ''),
        get(listings, 'transactionArea'),
      ),
      'title',
      '',
    );
  } else {
    return get(row, 'managerNotificationType.title', '');
  }
};
